import * as React from "react";
import { MainContextProvider } from "./main-context";
// import Login from "../views/Pages/Login";

class GlobalState extends React.Component {
  state = {
    isAuthenticated: false,
    authToken: "123",
    userName: "",
    testValue: 100,
    msgShow: false,
    msgTitle: "My Starting Title",
    msgText: "This is my starting error message.",
    msgColor: "info", // options: "info","alert","danger"
    datetimeLocked: false,
    allowAddLeg: false,
  };

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.dashboardMessage = this.dashboardMessage.bind(this);
    this.setContextState = this.setContextState.bind(this);
  }

  login() {
    this.setState({ isAuthenticated: true });
  }

  logout() {
    this.setState({ isAuthenticated: false });
    sessionStorage.clear();
    // Redirect to home page
    // this.context.router.replace("/login");
  }

  dashboardMessage(title, message, color, msgShow = true) {
    // console.log("Dashboard Message Called, color = " + color);
    this.setState({
      msgShow: msgShow,
      msgTitle: title,
      msgText: message,
      msgColor: color,
    });
  }

  setContextState(key, value) {
    this.setState((prevState) => ({
      [key]: value,
    }));
  }

  render() {
    return (
      <MainContextProvider
        value={{
          isAuthenticated: this.state.isAuthenticated,
          authToken: this.state.authToken,
          testValue: this.state.testValue,
          login: this.login,
          logout: this.logout,
          dashboardMessage: this.dashboardMessage,
          msgShow: this.state.msgShow,
          msgTitle: this.state.msgTitle,
          msgText: this.state.msgText,
          msgColor: this.state.msgColor,
          datetimeLocked: this.state.datetimeLocked,
          allowAddLeg: this.state.allowAddLeg,
          setContextState: this.setContextState,
        }}
      >
        {this.props.children}
      </MainContextProvider>
    );
  }
}

export default GlobalState;
